import Swal, { SweetAlertIcon, SweetAlertPosition } from 'sweetalert2';

interface ToastOptions {
    title?: string;
    type?: SweetAlertIcon;
    position?: SweetAlertPosition;
    showConfirmButton?: boolean;
    timerDuration?: number;
    target?: string | HTMLElement;
}

export const showToast = (options: ToastOptions) => {
    // Provide default values if not specified in options
    const { title, type = 'success', position = 'top-end', target, showConfirmButton = false, timerDuration = 3000 } = options;

    // Check if it's a mobile screen (width <= 768px)
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;

    // Adjust position for mobile when bottom-right is specified
    // On mobile, bottom-right becomes bottom with proper spacing for better visibility
    let adjustedPosition = position;
    if (isMobile && position === 'bottom-right') {
        adjustedPosition = 'bottom';
    }

    const toast: any = Swal.mixin({
        toast: true,
        position: adjustedPosition,
        showConfirmButton,
        timer: timerDuration,
        customClass: {
            container: 'toast',
            // Add bottom spacing for mobile bottom position
            ...(isMobile &&
                adjustedPosition === 'bottom' && {
                    popup: 'mobile-bottom-toast',
                }),
        },
        target,
    });

    const alert = Swal.getPopup();
    // console.log('called2', alert);

    if (alert === null) {
        toast.fire({
            icon: type,
            title,
            padding: '10px 20px',
        });
    }
};
